import Guard from 'arg-guard'

import Casing from '../helpers/casing'

/**
 * Defined structure of key event data.
 *
 * @export KeyEvent
 * @class KeyEvent
 */
export default class KeyEvent {

    /**
     * Creates an instance of KeyEvent.
     * @param {string} keyName
     * @param {number} whichCode
     * @param {Object} overrides
     * @memberof KeyEvent
     */
    constructor(keyName, whichCode, overrides) {
        Guard.throwIf(keyName, 'keyName')
        Guard.throwIf(whichCode, 'whichCode')

        this.key = overrides && overrides.key || Casing.properCase(keyName)
        this.code = overrides && overrides.code || Casing.properCase(keyName)

        this.view = window
        this.bubbles = true
        this.cancelable = true
    }
}
